import { DataFreshnessBadge } from '../components/DataFreshnessBadge'
import {
  useCompanyProductOverrides,
  useErpInventory,
  useInternalProductInfo,
  useJdProductCatalog,
  usePlatformProductMappings,
  useProductImageOverrides,
} from '../platform'
import { InternalProductInfoView } from './InternalProductInfoView'

const shanghaiDate = (value: Date) => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(value)

export function CompanyProductLibraryPage() {
  const company = useInternalProductInfo()
  const mappings = usePlatformProductMappings()
  const jdCatalog = useJdProductCatalog()
  const companyOverrides = useCompanyProductOverrides()
  const imageOverrides = useProductImageOverrides()
  const erpInventory = useErpInventory()

  if (company.loading || mappings.loading || jdCatalog.loading || companyOverrides.loading || imageOverrides.loading || erpInventory.loading) return <div className="loading-state">正在加载公司产品库…</div>
  if (company.error || mappings.error || companyOverrides.error || imageOverrides.error || !company.data || !mappings.data || !companyOverrides.data || !imageOverrides.data) {
    return <div className="error-state"><h1>公司产品库不可用</h1><p>{company.error || mappings.error || companyOverrides.error || imageOverrides.error || '公司产品数据不存在'}</p></div>
  }
  const erpExportDate = erpInventory.data?.source.exportedAt
    ? shanghaiDate(new Date(erpInventory.data.source.exportedAt))
    : ''
  const erpInventoryCurrent = erpExportDate === shanghaiDate(new Date())
  return (
    <div className={`page-stack product-master-page company-product-library-page${erpInventoryCurrent ? '' : ' is-erp-data-stale'}`}>
      <div className="page-title-row">
        <div><h1>公司产品库</h1><p>全公司店铺共用的图文商品资料、产品编码、条码、采购成本和属性。</p></div>
        <div className="page-title-actions">
          <DataFreshnessBadge date={company.data.generatedAt} label="资料更新于" mode="on-demand" />
          {erpInventory.data && <DataFreshnessBadge date={erpInventory.data.source.exportedAt} label="ERP库存截至" mode="on-demand" />}
          <span className="company-source-note" title={company.data.source.file}>源表 {company.data.source.file.split('/').pop()}</span>
        </div>
      </div>
      {jdCatalog.error && <p className="internal-product-source is-warning">京东SKU参考目录加载失败，基础公司产品资料仍可查看：{jdCatalog.error}</p>}
      {erpInventory.error && <p className="internal-product-source is-warning">ERP库存加载失败，库存列暂时显示为“—”：{erpInventory.error}</p>}
      <InternalProductInfoView
        companyData={company.data}
        companyOverrides={companyOverrides.data}
        imageOverrides={imageOverrides.data}
        platformMappings={mappings.data.mappings}
        jdCatalog={jdCatalog.data || undefined}
        erpInventory={erpInventory.data || undefined}
        reloadCompanyOverrides={companyOverrides.reload}
        reloadImageOverrides={imageOverrides.reload}
      />
    </div>
  )
}
